<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>按钮</span>
      </div>
      <div>
        <el-row class="margin-bottom-20">
          <el-button type="primary" @click="buttonLoading('primary')" :loading="primaryButtonIsLoading">Submit</el-button>
          <el-button type="primary" disabled>Submit</el-button>
          <el-button type="primary" @click="buttonLoading('primary')" :loading="primaryButtonIsLoading" size="small">Submit</el-button>
          <el-button @click="buttonLoading('default')" :loading="defaultButtonIsLoading">Submit</el-button>
          <el-button disabled>Submit</el-button>
          <el-button @click="buttonLoading('default')" :loading="defaultButtonIsLoading" size="small">Submit</el-button>
          <el-button type="danger" plain @click="buttonLoading('danger')" :loading="dangerButtonIsLoading">Submit</el-button>
          <el-button type="danger" plain disabled>Submit</el-button>
          <el-button type="danger" plain @click="buttonLoading('danger')" :loading="dangerButtonIsLoading" size="small">Submit</el-button>
        </el-row>
        <el-row class="margin-bottom-20">
          <el-button class="mixed-button" type="primary" @click="buttonLoading('primarymixed')" :loading="primaryMixedButtonIsLoading"><i class="el-icon-s-goods"></i>Pay Now</el-button>
          <el-button class="mixed-button" type="primary" disabled><i class="el-icon-s-goods"></i>Pay Now</el-button>
          <el-button class="mixed-button" type="primary" @click="buttonLoading('primarymixed')" :loading="primaryMixedButtonIsLoading" size="small"><i class="el-icon-s-goods"></i>Pay Now</el-button>
          <el-button class="mixed-button" @click="buttonLoading('defaultmixed')" :loading="defaultMixedButtonIsLoading"><i class="el-icon-s-goods"></i>Pay Now</el-button>
          <el-button class="mixed-button" disabled><i class="el-icon-s-goods"></i>Pay Now</el-button>
          <el-button class="mixed-button" @click="buttonLoading('defaultmixed')" :loading="defaultMixedButtonIsLoading" size="small"><i class="el-icon-s-goods"></i>Pay Now</el-button>
        </el-row>
        <el-row class="margin-bottom-20">
          <rhcn-button class="icon-button" type="primary" @click="buttonLoading('primaryicon')" :loading="primaryIconButtonIsLoading"><i class="el-icon-s-tools"></i></rhcn-button>
          <rhcn-button class="icon-button" type="primary" disabled><i class="el-icon-s-tools"></i></rhcn-button>
          <rhcn-button class="icon-button" type="primary" @click="buttonLoading('primaryicon')" :loading="primaryIconButtonIsLoading" size="small"><i class="el-icon-s-tools"></i></rhcn-button>
          <rhcn-button class="icon-button" @click="buttonLoading('defaulticon')" :loading="defaultIconButtonIsLoading"><i class="el-icon-s-tools"></i></rhcn-button>
          <rhcn-button class="icon-button" disabled><i class="el-icon-s-tools"></i></rhcn-button>
          <rhcn-button class="icon-button" @click="buttonLoading('defaulticon')" :loading="defaultIconButtonIsLoading" size="small"><i class="el-icon-s-tools"></i></rhcn-button>
        </el-row>
      </div>
    </el-card>
    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix">
        <span>提示</span>
      </div>
      <div>
        <el-button @click="showMessage('info')">Info/Success</el-button>
        <el-button @click="showMessage('warning')">Warning</el-button>
        <el-button @click="showMessage('error')">Error</el-button>
        <el-button @click="showMessage('login')">Login</el-button>
        <el-button @click="showMessage('close')">Close</el-button>
        <el-button @click="showNotify()">强提示</el-button>
      </div>
      <div class="margin-top-20">
        <el-button @click="showModal('warn')">警告强提示弹窗</el-button>
        <el-button @click="showModal('info')">功能提示弹窗</el-button>
        <el-button @click="showModal('error')">危险信息强提示弹窗</el-button>
      </div>
    </el-card>
    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix">
        <span>自定义Dialog组件</span>
      </div>
      <div>
        <el-button @click="openBasicDialog">基础弹窗</el-button>
        <el-button @click="openCustomTitleDialog">自定义标题栏弹窗</el-button>
        <el-button @click="openCustomFooterDialog">自定义底部弹窗</el-button>
        <el-button @click="openFullFeaturesDialog">完整功能弹窗</el-button>
      </div>

      <!-- 基础弹窗 -->
      <rhcn-dialog
        :visible.sync="basicDialogVisible"
        title="基础弹窗"
        width="600px"
      >
        <div>这是一个基础弹窗，使用默认的标题和底部按钮</div>
      </rhcn-dialog>

      <!-- 自定义标题栏弹窗 -->
      <rhcn-dialog
        :visible.sync="customTitleDialogVisible"
        title="自定义标题弹窗"
        width="600px"
        :custom-title="true"
      >
        <div>这个弹窗使用了自定义的标题栏样式，右侧有个方形的关闭按钮</div>
      </rhcn-dialog>

      <!-- 自定义底部弹窗 -->
      <rhcn-dialog
        :visible.sync="customFooterDialogVisible"
        title="自定义底部弹窗"
        width="600px"
      >
        <div>这个弹窗使用了自定义的底部内容</div>
        <template #footer>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div>左侧自定义内容</div>
            <div>
              <el-button @click="customFooterDialogVisible = false">取消</el-button>
              <el-button type="primary" @click="handleCustomFooterConfirm">确认</el-button>
            </div>
          </div>
        </template>
      </rhcn-dialog>

      <!-- 完整功能弹窗 -->
      <rhcn-dialog
        :visible.sync="fullFeaturesDialogVisible"
        title="完整功能弹窗"
        width="600px"
        :custom-title="true"
        :confirm-loading="confirmLoading"
        :confirm-disabled="confirmDisabled"
        :footer-align="footerAlign"
        confirm-text="提交表单"
        cancel-text="返回"
        @confirm="handleFullFeaturesConfirm"
      >
        <div>
          <p>这个弹窗展示了更多的自定义功能：</p>
          <ul>
            <li>自定义标题栏</li>
            <li>自定义按钮文本</li>
            <li>按钮加载状态</li>
            <li>按钮禁用状态</li>
            <li>底部对齐方式</li>
          </ul>
          <div class="margin-top-20">
            <el-checkbox v-model="confirmDisabled">禁用确认按钮</el-checkbox>
            <el-radio-group v-model="footerAlign" style="margin-left: 20px;">
              <el-radio label="left">左对齐</el-radio>
              <el-radio label="right">右对齐</el-radio>
            </el-radio-group>
          </div>
        </div>
      </rhcn-dialog>
    </el-card>
    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix">
        <span>日历</span>
      </div>
      <div>
        <el-form :model="formDate" ref="formDateRef" :inline="true" label-position="top" :rules="formDateRules">
          <el-form-item label="日期区间选择器" prop="datepicker1">
            <div style="display:flex;">
              <rhcn-datepicker
                v-model="formDate.datepicker1"
                :picker-options="datePickerOptions1"></rhcn-datepicker>
              <rhcn-datepicker
                class="margin-left-20"
                v-model="formDate.datepicker2"
                :picker-options="datePickerOptions2"></rhcn-datepicker>
            </div>
          </el-form-item>
          <el-form-item label="日期区间选择器">
            <div style="display:flex;">
              <rhcn-datepicker
                v-model="formDate.datepicker3"
                :picker-options="datePickerOptions1"
                size="small"></rhcn-datepicker>
            </div>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button type="primary" @click="dateSubmit">提交</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix">
        <span>表单</span>
      </div>
      <div>
        <el-form :model="form" ref="formRef" :inline="true" label-position="top" :rules="rules">
          <div>
            <el-form-item label="基础输入框" prop="input1">
              <el-input v-model="form.input1" placeholder="Type something" />
            </el-form-item>
            <el-form-item label="Disabled">
              <el-input disabled placeholder="Type something" />
            </el-form-item>
            <el-form-item label="Small" prop="input1small" size="small">
              <el-input v-model="form.input1small" placeholder="Type something" />
            </el-form-item>
          </div>
          <div>
            <el-form-item label="复合输入框1" prop="input2">
              <rhcn-input v-model="form.input2" @keyup.enter.native="search" @click="search" :loading="searchLoading" placeholder="Search" suffix="search">
              </rhcn-input>
            </el-form-item>
            <el-form-item label="Disabled">
              <rhcn-input value="2111" disabled suffix="search" placeholder="Search"></rhcn-input>
            </el-form-item>
            <el-form-item label="small" prop="input2small">
              <rhcn-input size="small" v-model="form.input2small" @click="search" :loading="searchLoading" placeholder="Search" suffix="search">
              </rhcn-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="复合输入框2" prop="input3">
              <rhcn-input v-model="form.input3" placeholder="Type something" prepend="select" @keyup.enter.native="search" :loading="searchLoading">
                <el-select v-model="form.input3Select" slot="prepend">
                  <el-option label="+86" value="1"></el-option>
                  <el-option label="+81" value="2"></el-option>
                  <el-option label="+82" value="3"></el-option>
                </el-select>
              </rhcn-input>
            </el-form-item>
            <el-form-item label="Disabled">
              <rhcn-input v-model="form.input3" placeholder="Type something" prepend="select" disabled>
                <el-select v-model="form.input3Select" slot="prepend" disabled>
                  <el-option label="+86" value="1"></el-option>
                  <el-option label="+81" value="2"></el-option>
                  <el-option label="+82" value="3"></el-option>
                </el-select>
              </rhcn-input>
            </el-form-item>
            <el-form-item label="small" prop="input3small">
              <rhcn-input v-model="form.input3small" placeholder="Type something" prepend="select" size="small">
                <el-select v-model="form.input3Select" slot="prepend">
                  <el-option label="+86" value="1"></el-option>
                  <el-option label="+81" value="2"></el-option>
                  <el-option label="+82" value="3"></el-option>
                </el-select>
              </rhcn-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="基础选择器" prop="select1">
              <el-select v-model="form.select1" placeholder="Select" clearable filterable no-match-text="No data found">
                <el-option label="+86" value="1"></el-option>
                <el-option label="+81" value="2"></el-option>
                <el-option label="+82" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Disabled">
              <el-select value="1" placeholder="Select" clearable filterable disabled>
                <el-option label="+86" value="1"></el-option>
                <el-option label="+81" value="2"></el-option>
                <el-option label="+82" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Small" prop="select1small">
              <el-select v-model="form.select1small" placeholder="Select" clearable filterable size="small" no-match-text="No data found">
                <el-option label="+86" value="1"></el-option>
                <el-option label="+81" value="2"></el-option>
                <el-option label="+82" value="3"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="多标签型输入框" prop="inputMultiple">
              <rhcn-input :multiple="true" v-model="form.inputMultiple"></rhcn-input>
            </el-form-item>
            <el-form-item label="Disabled">
              <rhcn-input :multiple="true" v-model="form.inputMultipleDisabled" :disabled="true"></rhcn-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="多选选择器" prop="selectMultiple">
              <rhcn-select :multiple="true" v-model="form.selectMultiple" :options="options1"></rhcn-select>
            </el-form-item>
            <el-form-item label="Disabled">
              <rhcn-select :multiple="true" v-model="form.selectMultiple" :options="options1" disabled></rhcn-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="联级选择器（单选）" prop="cascader1">
              <!-- <el-cascader
                v-model="form.cascader1"
                :options="cascaderOptions"
                filterable>
                <template #default="{ node, data }">
                  <span v-if="data.type === 'title'">{{data.label}}</span>
                  <span v-else>{{getCascaderInfo(node, data)}}</span>
                </template>
              </el-cascader> -->
              <RhcnCascader
                :value.sync="form.cascader1"
                :options="cascaderOptions"
                @change="onRhcnCascaderChange"
              ></RhcnCascader>
            </el-form-item>
            <el-form-item label="Disabled">
              <el-cascader
                :value="form.cascader1"
                :options="cascaderOptions"
                disabled>
              </el-cascader>
            </el-form-item>
            <el-form-item label="Small">
              <el-cascader
                v-model="form.cascader1"
                :options="cascaderOptions"
                size="small">
              </el-cascader>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="联级选择器（多选）" prop="cascader2">
              <el-cascader
                popper-class="multiple"
                v-model="form.cascader2"
                :props="{ multiple: true }"
                :options="cascaderOptions">
              </el-cascader>
            </el-form-item>
            <el-form-item label="Disabled">
              <el-cascader
                :value="[[ 'zhinan', 'shejiyuanze', 'yizhi']]"
                :props="{ multiple: true }"
                :options="cascaderOptions"
                disabled>
              </el-cascader>
            </el-form-item>
            <el-form-item label="Small">
              <el-cascader
                v-model="form.cascader2"
                :props="{ multiple: true }"
                :options="cascaderOptions"
                size="small">
              </el-cascader>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" @click="formSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix">
        <span>上传</span>
      </div>
      <div style="width: 590px">
        <rhcn-upload
          tip="Only excl files, not greater than 5m"
          :uploading="upload.uploading"
          :upload-progress="upload.progress"
          :file-list="upload.fileList"
          @on-change="uploadChange"
          @on-remove="removeHandler"></rhcn-upload>
      </div>
    </el-card>
    <el-card class="box-card margin-top-20">
      <div slot="header" class="clearfix">
        <span>表格/搜索</span>
      </div>
      <div class="app-content-wrapper">
        <div class="search-wrapper">
          <search-component ref="search"
                            :search-condition="searchCondition"
                            router-name="/demo">
          </search-component>
        </div>
        <div class="table-wrapper">
          <custom-table :table-set="tableCondition"
                        :service-function="getSubscriptionList"
                        ref="table"
                        router-name="/demo">
          </custom-table>
        </div>
        <custom-message ref="customMessage"></custom-message>
      </div>
    </el-card>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>
import RhcnButton from '@/components/form/button.vue';
import RhcnCascader from '@/components/form/cascader.vue';
import RhcnDatepicker from '@/components/form/datepicker.vue';
import RhcnInput from '@/components/form/input.vue';
import RhcnSelect from '@/components/form/select.vue';
import RhcnUpload from '@/components/form/upload.vue';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import {
  ShowSuccessMessage,
  ShowWarningMessage,
  ShowErrorMessage,
  showTimeMessage,
  showNotifyMessage,
} from '@/components/modal/tips/message-tips.js';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import RhcnDialog from '@/componentsV2/base-cmps/dialog/index.vue';
import Http from '@/utils/http/index';
import { getTodayParams, formatDateDisplay } from '@/utils/tools/time';
import { getSubscriptionList, unsubscrible } from '@/views/subscription/api/subscription';

export default {
  components: {
    RhcnButton,
    RhcnInput,
    RhcnSelect,
    RhcnUpload,
    RhcnCascader,
    RhcnDatepicker,
    CustomMessage,
    CustomTable,
    SearchComponent,
    RhcnDialog,
  },
  data() {
    const that = this;
    return {
      tags: [],
      primaryButtonIsLoading: false,
      defaultButtonIsLoading: false,
      dangerButtonIsLoading: false,
      primaryMixedButtonIsLoading: false,
      defaultMixedButtonIsLoading: false,
      primaryIconButtonIsLoading: false,
      defaultIconButtonIsLoading: false,
      loginMessageTime: 0,
      formDate: {
        datepicker1: null,
        datepicker2: null,
      },
      formDateRules: {
        datepicker1: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        datepicker2: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
      },
      datePickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        // shortcuts: [
        //   {
        //     text: 'Yesterday',
        //     onClick(picker) {
        //       const date1 = new Date();
        //       date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 1);
        //       date1.setHours(0, 0, 0, 0);
        //       picker.$emit('pick', date1);
        //       const date2 = new Date();
        //       date2.setTime(date2.getTime() - 3600 * 1000 * 24 * 1);
        //       date2.setHours(23, 59, 59, 999);
        //       that.datepicker2 = date2;
        //     },
        //   },
        //   {
        //     text: 'Last 7 days',
        //     onClick(picker) {
        //       const date1 = new Date();
        //       date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 6);
        //       date1.setHours(0, 0, 0, 0);
        //       picker.$emit('pick', date1);
        //       const date2 = new Date();
        //       date2.setHours(23, 59, 59, 999);
        //       that.datepicker2 = date2;
        //     },
        //   },
        //   {
        //     text: 'Last Month',
        //     onClick(picker) {
        //       const date1 = new Date();
        //       date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 29);
        //       date1.setHours(0, 0, 0, 0);
        //       picker.$emit('pick', date1);
        //       const date2 = new Date();
        //       date2.setHours(23, 59, 59, 999);
        //       that.datepicker2 = date2;
        //     },
        //   },
        // ],
      },
      datePickerOptions2: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        // shortcuts: [
        //   {
        //     text: 'Yesterday',
        //     onClick(picker) {
        //       const date1 = new Date();
        //       date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 1);
        //       date1.setHours(0, 0, 0, 0);
        //       that.datepicker1 = date1;
        //       const date2 = new Date();
        //       date2.setTime(date2.getTime() - 3600 * 1000 * 24 * 1);
        //       date2.setHours(23, 59, 59, 999);
        //       picker.$emit('pick', date2);
        //     },
        //   },
        //   {
        //     text: 'Last 7 days',
        //     onClick(picker) {
        //       const date1 = new Date();
        //       date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 6);
        //       date1.setHours(0, 0, 0, 0);
        //       that.datepicker1 = date1;
        //       const date2 = new Date();
        //       date2.setHours(23, 59, 59, 999);
        //       picker.$emit('pick', date2);
        //     },
        //   },
        //   {
        //     text: 'Last Month',
        //     onClick(picker) {
        //       const date1 = new Date();
        //       date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 29);
        //       date1.setHours(0, 0, 0, 0);
        //       that.datepicker1 = date1;
        //       const date2 = new Date();
        //       date2.setHours(23, 59, 59, 999);
        //       picker.$emit('pick', date2);
        //     },
        //   },
        // ],
      },
      form: {
        input1: '',
        input1small: '',
        input2: '22',
        input2small: '',
        input3: '',
        input3small: '',
        input3Select: '1',
        select1: '',
        select1small: '',
        inputMultiple: [],
        inputMultipleDisabled: ['选项1'],
        selectMultiple: ['选项1'],
        cascader1: [],
        cascader2: [],
      },
      rules: {
        input1: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        input1small: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        input2: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        input2small: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        input3: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        input3small: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        select1: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        select1small: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        inputMultiple: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        selectMultiple: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        cascader1: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
        cascader2: [
          { required: true, message: '请输入XXXX', trigger: 'blur' },
        ],
      },
      searchLoading: false,
      options1: [
        {
          value: '选项1',
          label: '黄金糕',
        },
        {
          value: '选项2',
          label: '双皮奶',
        },
        {
          value: '选项3',
          label: '选项3',
        },
        {
          value: '选项4',
          label: '选项4',
        },
      ],
      cascaderOptions: [{
        value: 'title',
        label: '标题',
        disabled: true,
        type: 'title',
      }, {
        value: 'zhinan',
        label: '指南',
        children: [{
          value: 'subtitle',
          label: '子标题',
          disabled: true,
          type: 'title',
        }, {
          value: 'shejiyuanze',
          label: '设计原则',
          children: [{
            value: 'yizhi',
            label: '一致',
          }, {
            value: 'fankui',
            label: '反馈',
          }, {
            value: 'xiaolv',
            label: '效率',
          }, {
            value: 'kekong',
            label: '可控',
          }],
        }, {
          value: 'daohang',
          label: '导航',
          children: [{
            value: 'cexiangdaohang',
            label: '侧向导航',
          }, {
            value: 'dingbudaohang',
            label: '顶部导航',
          }],
        }, {
          value: 'daohang',
          label: '导航2',
          children: [],
        }],
      }, {
        value: 'zujian',
        label: '组件',
        children: [{
          value: 'basic',
          label: 'Basic',
          children: [{
            value: 'layout',
            label: 'Layout 布局',
          }, {
            value: 'color',
            label: 'Color 色彩',
          }, {
            value: 'typography',
            label: 'Typography 字体',
          }, {
            value: 'icon',
            label: 'Icon 图标',
          }, {
            value: 'button',
            label: 'Button 按钮',
          }],
        }, {
          value: 'form',
          label: 'Form',
          children: [{
            value: 'radio',
            label: 'Radio 单选框',
          }, {
            value: 'checkbox',
            label: 'Checkbox 多选框',
          }, {
            value: 'input',
            label: 'Input 输入框',
          }, {
            value: 'input-number',
            label: 'InputNumber 计数器',
          }, {
            value: 'select',
            label: 'Select 选择器',
          }, {
            value: 'cascader',
            label: 'Cascader 级联选择器',
          }, {
            value: 'switch',
            label: 'Switch 开关',
          }, {
            value: 'slider',
            label: 'Slider 滑块',
          }, {
            value: 'time-picker',
            label: 'TimePicker 时间选择器',
          }, {
            value: 'date-picker',
            label: 'DatePicker 日期选择器',
          }, {
            value: 'datetime-picker',
            label: 'DateTimePicker 日期时间选择器',
          }, {
            value: 'upload',
            label: 'Upload 上传',
          }, {
            value: 'rate',
            label: 'Rate 评分',
          }, {
            value: 'form',
            label: 'Form 表单',
          }],
        }, {
          value: 'data',
          label: 'Data',
          children: [{
            value: 'table',
            label: 'Table 表格',
          }, {
            value: 'tag',
            label: 'Tag 标签',
          }, {
            value: 'progress',
            label: 'Progress 进度条',
          }, {
            value: 'tree',
            label: 'Tree 树形控件',
          }, {
            value: 'pagination',
            label: 'Pagination 分页',
          }, {
            value: 'badge',
            label: 'Badge 标记',
          }],
        }, {
          value: 'notice',
          label: 'Notice',
          children: [{
            value: 'alert',
            label: 'Alert 警告',
          }, {
            value: 'loading',
            label: 'Loading 加载',
          }, {
            value: 'message',
            label: 'Message 消息提示',
          }, {
            value: 'message-box',
            label: 'MessageBox 弹框',
          }, {
            value: 'notification',
            label: 'Notification 通知',
          }],
        }, {
          value: 'navigation',
          label: 'Navigation',
          children: [{
            value: 'menu',
            label: 'NavMenu 导航菜单',
          }, {
            value: 'tabs',
            label: 'Tabs 标签页',
          }, {
            value: 'breadcrumb',
            label: 'Breadcrumb 面包屑',
          }, {
            value: 'dropdown',
            label: 'Dropdown 下拉菜单',
          }, {
            value: 'steps',
            label: 'Steps 步骤条',
          }],
        }, {
          value: 'others',
          label: 'Others',
          children: [{
            value: 'dialog',
            label: 'Dialog 对话框',
          }, {
            value: 'tooltip',
            label: 'Tooltip 文字提示',
          }, {
            value: 'popover',
            label: 'Popover 弹出框',
          }, {
            value: 'card',
            label: 'Card 卡片',
          }, {
            value: 'carousel',
            label: 'Carousel 走马灯',
          }, {
            value: 'collapse',
            label: 'Collapse 折叠面板',
          }],
        }],
      }, {
        value: 'ziyuan',
        label: '资源',
        children: [{
          value: 'axure',
          label: 'Axure Components',
        }, {
          value: 'sketch',
          label: 'Sketch Templates',
        }, {
          value: 'jiaohu',
          label: '组件交互文档',
        }],
      }, {
        value: 'value1',
        label: '选项',
      }],
      upload: {
        uploading: false,
        progress: 0,
        fileList: [
          {
            name: 'food.jpeg',
            url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
            size: 6667722,
            uploadTime: '2020 10.10 13:12:00',
          },
          {
            name: 'food.doc',
            url: 'https://fuss10.elemecdn.com/100.docx',
            size: 6667722,
            uploadTime: '2020 10.10 13:12:00',
          },
          {
            name: 'food.xls',
            url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
            size: 6667722,
            uploadTime: '2020 10.10 13:12:00',
          },
          {
            name: 'food.pdf',
            url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
            size: 6667722,
            uploadTime: '2020 10.10 13:12:00',
          },
        ],
      },
      messageType: 'info',
      //  ----------------------------Table--------------------------
      getTodayParams,
      appItem: {},
      appTypeList: [],
      appTypeListAndAll: [],
      searchCondition: [
        {
          key: 'contractId',
          name: 'message.subscription.contractNo',
          type: 'input',
          defValue: '',
        },
        {
          key: 'dataStatus',
          name: 'message.tableCommon.status',
          type: 'select',
          defValue: '',
          isInternationalization: true,
          options: [
            { label: 'message.searchCommon.all', value: '' }, // 全部
            { label: 'message.subscription.statusData.0', value: '0' }, // 未生效
            { label: 'message.subscription.statusData.1', value: '1' }, // 生效
            { label: 'message.subscription.statusData.2', value: '2' }, // 关闭
            { label: 'message.subscription.statusData.3', value: '3' }, // 已取消
          ],
        },
        {
          key: 'selfExecute',
          name: 'message.subscription.paymentMethod',
          type: 'select',
          defValue: '',
          isInternationalization: true,
          options: [
            { label: 'message.searchCommon.all', value: '' }, // 全部
            { label: 'message.subscription.paymentMethodData.1', value: '1' }, // 自动
            { label: 'message.subscription.paymentMethodData.2', value: '2' }, // 商户发起
          ],
        },
      ],
      tableCondition: [
        { // 订阅合同号
          titleBar: { type: 'text', title: 'message.subscription.contractNo', filterKey: 'contractId' },
          key: 'contractId',
          type: 'text',
          itemWidth: '250px',
        },
        { // 开始日期
          titleBar: { type: 'text', title: 'message.subscription.startTime' },
          key: 'createDate',
          type: 'text',
        },
        { // 结束日期
          titleBar: { type: 'text', title: 'message.subscription.endTime' },
          key: 'expireDate',
          type: 'text',
        },
        { // 扣款频率
          titleBar: { type: 'text', title: 'message.subscription.frequency' },
          key: 'frequencyPoint',
          type: 'text',
          textFunc: (data) => this.$t(`message.subscription.frequencyData.${data.frequencyType}`, { day: data.frequencyPoint }),
        },
        { // 付款方式
          titleBar: { type: 'text', title: 'message.subscription.paymentMethod', filterKey: 'selfExecute' },
          key: 'selfExecute',
          type: 'text',
          textFunc: (data) => this.$t(`message.subscription.paymentMethodData.${data.selfExecute}`),
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status', filterKey: 'dataStatus' },
          key: 'dataStatus',
          type: 'text',
          textFunc: (data) => this.$t(`message.subscription.statusData.${data.dataStatus}`),
          itemStyle: (data) => {
            if (data.dataStatus === '1') { // 生效
              return 'background:rgba(0,221,40,0.15);padding:3px 8px;border-radius:4px;';
            }
            return 'background:rgba(252,100,45,0.15);padding:3px 8px;border-radius:4px;'; // 未生效,取消,关闭
          },
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          subTableDisplays: [
            { // 详情
              type: 'text_button',
              textFunc: () => 'message.tableCommon.details',
              func: (data) => {
                this.$router.push({ path: '/subscription/order/view', query: { contractId: data.contractId } });
              },
            },
            { // 取消
              type: 'text_button',
              textFunc: () => 'message.tableCommon.cancel',
              isDisplayFunc: (data) => data.dataStatus === '1',
              func: (data) => {
                this.$refs.customMessage.openHttpModal({
                  contentHtml: `${this.$t('message.subscription.cancelConfirm')}?`,
                  httpFunction: unsubscrible,
                  params: { contractId: data.contractId },
                  successFunction: this.onRefreshTable,
                });
              },
            },
          ],
        },
      ],
      basicDialogVisible: false,
      customTitleDialogVisible: false,
      customFooterDialogVisible: false,
      fullFeaturesDialogVisible: false,
      confirmLoading: false,
      confirmDisabled: false,
      footerAlign: 'right',
    };
  },
  created() {
  },
  methods: {
    buttonLoading(type) {
      if (type === 'primary') {
        this.primaryButtonIsLoading = true;
        setTimeout(() => {
          this.primaryButtonIsLoading = false;
        }, 5000);
      } else if (type === 'default') {
        this.defaultButtonIsLoading = true;
        setTimeout(() => {
          this.defaultButtonIsLoading = false;
        }, 5000);
      } else if (type === 'danger') {
        this.dangerButtonIsLoading = true;
        setTimeout(() => {
          this.dangerButtonIsLoading = false;
        }, 5000);
      } else if (type === 'primarymixed') {
        this.primaryMixedButtonIsLoading = true;
        setTimeout(() => {
          this.primaryMixedButtonIsLoading = false;
        }, 5000);
      } else if (type === 'defaultmixed') {
        this.defaultMixedButtonIsLoading = true;
        setTimeout(() => {
          this.defaultMixedButtonIsLoading = false;
        }, 5000);
      } else if (type === 'primaryicon') {
        this.primaryIconButtonIsLoading = true;
        setTimeout(() => {
          this.primaryIconButtonIsLoading = false;
        }, 5000);
      } else if (type === 'defaulticon') {
        this.defaultIconButtonIsLoading = true;
        setTimeout(() => {
          this.defaultIconButtonIsLoading = false;
        }, 5000);
      }
    },
    showMessage(type) {
      if (type === 'info') {
        ShowSuccessMessage('Failure: Because the user does not existFailure: Because the user does not existBecause the user does not exist');
      } else if (type === 'warning') {
        ShowWarningMessage('Warning');
      } else if (type === 'error') {
        ShowErrorMessage('Failure: Because the user does not exist');
      } else if (type === 'login') {
        this.loginMessageTime = 6;
        showTimeMessage('The password has been changed');
      } else if (type === 'close') {
        ShowSuccessMessage('The password has been changed', true);
      }
    },
    showNotify() {
      showNotifyMessage('Enterprise Legal Name', 'If the ID card contains a face and a back,it is submitted as a multi-page PDF file;');
    },
    showModal(type) {
      this.messageType = type;
      this.$refs.customMessage.openHttpModal({
        titleHtml: 'Are you sure you want to delete the file?',
        contentHtml: 'Your information has expired. You can upload the latest KYC file to update your status. If you need help, ' +
        'please consult 9876789 customer service. We disappear at 18 and are ready to serve you',
        // httpFunction: () => {
        //   return new Promise();
        // },
      }, type);
    },
    dateSubmit() {
      this.$refs.formDateRef.validate((valid) => {
        console.log(valid);
      });
    },
    formSubmit() {
      this.$refs.formRef.validate((valid) => {
        console.log(valid);
      });
    },
    search() {
      this.searchLoading = true;
      setTimeout(() => {
        this.searchLoading = false;
      }, 5000);
    },
    uploadChange(file, fileList) {
      const options = {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          if (e.lengthComputable) {
            this.upload.uploading = true;
            this.upload.progress = 0;
            const rate = e.loaded / e.total;
            if (rate < 1) {
              this.upload.progress = Math.round(rate * 100);
            } else {
              this.upload.progress = 100;
            }
          }
        },
      };
      const data = new FormData();
      data.append('file', file.raw);
      Http.post('/payee/idCardUpload', data, options).then(res => {
        setTimeout(() => {
          console.log('ress', res, file);
          this.upload.fileList.push({
            url: res,
            size: file.size,
            name: file.name,
            uploadTime: formatDateDisplay(new Date(), 'yyyy MM.DD HH:mm:ss'),
          });
          this.upload.uploading = false;
        }, 5000);
      }).catch(() => {
        this.upload.uploading = false;
      });
    },
    removeHandler(item, index) {
      this.upload.fileList.splice(index, 1);
    },
    // ----------------------------------Table--------------------------------------
    getSubscriptionList,
    /**
     * 刷新当前表单
     */
    onRefreshTable() {
      this.$refs.table.refreshTable();
    },
    onRhcnCascaderChange(value) {
      console.log(value);
      console.log(this.form.cascader1);
    },
    openBasicDialog() {
      this.basicDialogVisible = true;
    },
    openCustomTitleDialog() {
      this.customTitleDialogVisible = true;
    },
    openCustomFooterDialog() {
      this.customFooterDialogVisible = true;
    },
    openFullFeaturesDialog() {
      this.fullFeaturesDialogVisible = true;
    },
    handleCustomFooterConfirm() {
      this.$message.success('自定义底部确认按钮点击');
      this.customFooterDialogVisible = false;
    },
    handleFullFeaturesConfirm() {
      this.confirmLoading = true;
      setTimeout(() => {
        this.$message.success('提交成功');
        this.confirmLoading = false;
        this.fullFeaturesDialogVisible = false;
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.el-form-item {
  width: 280px;
}
</style>
